shadow$provide[7] = function(require,module,exports) {
"use strict";
exports.__esModule = true;
exports.useMathbox = void 0;
var react_1 = require("react");
var MathboxAPIContext = (0, react_1.createContext)(null);
/**
 * Returns Mathbox API Selection object for the nearest enclosing Mathbox node.
 */
var useMathbox = function () {
    var selection = (0, react_1.useContext)(MathboxAPIContext);
    if (!selection) {
        throw new Error("useMathbox must be used within Mathbox or ContainedMathbox");
    }
    return selection;
};
exports.useMathbox = useMathbox;
exports["default"] = MathboxAPIContext;
//# sourceMappingURL=MathboxAPIContext.js.map
};